module.exports = __webpack_public_path__ + "img/tu-06.bdc07587.png";